import React, { useState, useEffect } from 'react';
import {
  Typography,
} from '@mui/material';
import Card from "@mui/material/Card";
import MKBox from "components/MKBox";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKAvatar from "components/MKAvatar";
import MKButton from "components/MKButton";
import profilePicture from "assets/images/bruce-mars.jpg";
import routes from "routes";
import bgImage from "assets/images/trainer-profile.jpg";
import { useParams } from "react-router-dom";
import Breadcrumbs from "examples/Breadcrumbs";
import SimpleFooter from "examples/Footers/SimpleFooter";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

function Author() {
  const { uidb64, token, trainerID, trainingCompanyID } = useParams();
  const [trainingCompanyList, setTrainingCompanyList] = useState([]);
  const [bbdata, setbbData] = useState([]);
  const [submitCompleted, setSubmitCompleted] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [socialMedia, setSocialMedia] = useState('');
  const [additionalContactDetails, setAdditionalContactDetails] = useState('');
  const [headQuartersDetails, setHeadQuartersDetails] = useState('');
  const [avatarBackgroundColor, setAvatarBackgroundColor] = useState('#ccc');

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/training-companyprofile-filter/${trainingCompanyID}/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          setbbData(data);
          setTrainingCompanyList(data);
          setSocialMedia(data.socialMedia);
          setHeadQuartersDetails(data.tcpHQAddress);
          setAdditionalContactDetails(data.additionalContactDetails);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  console.log("trainingCompanyList", trainingCompanyList);
  console.log("data", bbdata);

  const onAgreeClick = (e) => {
    const data = {
      uidb64: uidb64,
      token: token,
      trainerAcceptStatus: "Accept",
      trainingCompanyID: trainingCompanyID,
      trainerID: trainerID,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/redir-trainer-status-intodb/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setSubmitCompleted(true);
        } else {
          setSubmitCompleted(false);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };

  const DialogProfileClose = () => {
    setShowModal(false);
    window.location.href = "/portal";
  };

  const onDeclineClick = () => {
    const data = {
      uidb64: uidb64,
      token: token,
      trainerAcceptStatus: "Decline",
      trainingCompanyID: trainingCompanyID,
      trainerID: trainerID,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/redir-trainer-status-intodb/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setSubmitCompleted(true);
        } else {
          setSubmitCompleted(false);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };

  return (
    <>
      <DefaultNavbar
        routes={routes}
      />
      <MKBox bgColor="white">
        <MKBox
          minHeight="35rem"
          width="100%"
          sx={{
            backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
              `${linearGradient(
                rgba(gradients.dark.main, 0.3),
                rgba(gradients.dark.state, 0.3)
              )}, url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center center",
            display: "grid",
            placeItems: "center",
          }}
        />
        <Card
          sx={{
            p: 2,
            mx: { xs: 2, lg: 3 },
            // mt: -8,
            mb: 4,
            // backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
            backdropFilter: "saturate(200%) blur(30px)",
            boxShadow: ({ boxShadows: { xxl } }) => xxl,
          }}
        >
          <MKBox component="section" py={{ xs: 6, sm: 12 }}>
            <Container>
              <Grid container item xs={12} justifyContent="center" mx="auto">
                <MKBox mt={{ xs: -16, md: -20 }} textAlign="center">
                  {/* <MKAvatar src={profilePicture} alt="Burce Mars" size="xxl" shadow="xl" /> */}
                  <MKAvatar
                    src={`${process.env.REACT_APP_API_URL}${trainingCompanyList.companyLogo}/`}
                    alt="Profile Picture"
                    size="xxl"
                    style={{ backgroundColor: avatarBackgroundColor, marginRight: '10px' }}
                  />
                </MKBox>
                <Dialog
                  open={submitCompleted}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogTitle id="alert-dialog-title">
                    Notification !
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      Your Response has been succesfully submitted !
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <MKButton onClick={() => { setSubmitCompleted(false); DialogProfileClose(); }} color="primary" autoFocus>
                      OK
                    </MKButton>
                  </DialogActions>
                </Dialog>
                <Grid container justifyContent="center" py={6} style={{ marginTop: "-90px" }}>
                  <Grid item xs={12} md={12} mx={{ xs: "auto", sm: 6, md: 1 }}>
                    <MKBox display="flex" justifyContent="center" alignItems="center" mb={1}>
                      <Typography component="span" variant="body2" fontWeight="regular" color="text">
                        {trainingCompanyList.companyName} has invited you to join them as a trainer. You can now review the Training Partner details and choose to 'Accept' or 'Decline' the offer.
                      </Typography>
                    </MKBox>
                    <MKBox display="flex" justifyContent="center" alignItems="center" mb={1}>
                      <Typography variant="h3">{trainingCompanyList.companyName}</Typography>
                    </MKBox>
                    <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                      <Grid item xs={12}>
                        <Breadcrumbs
                          routes={[{ label: <span style={{ fontWeight: 'bold' }}>Training Partner's Basic Details</span> }]}
                        />
                      </Grid>
                    </Grid>

                    <Grid container spacing={4} mb={1}>
                      <Grid item xs={12}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          Trainings Offered :&nbsp;
                        </Typography>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "47px" }}>
                          {trainingCompanyList.trainingOffered}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container spacing={4} mb={1}>
                      <Grid item xs={6}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          Previous Clients :&nbsp;
                        </Typography>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "55px" }}>
                          {trainingCompanyList.clients}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          Supported Time Zone :&nbsp;
                        </Typography>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "18px" }}>
                          {trainingCompanyList.supportedClientTimezone}&nbsp;
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={4} mb={1}>
                      <Grid item xs={2}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          About Trainer :&nbsp;
                        </Typography>
                      </Grid>
                      <Grid item xs={10}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "0px" }}>
                          {trainingCompanyList.profile} <br />
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                      <Grid item xs={12}>
                        <Breadcrumbs
                          routes={[{ label: <span style={{ fontWeight: 'bold' }}>Training Partner's Head Quarters Details</span> }]}
                        />
                      </Grid>
                    </Grid>

                    <Grid container spacing={4} mb={1}>
                      <Grid item xs={6}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          Address Line 1 :&nbsp;
                        </Typography>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "37px" }}>
                          {/* {headQuartersDetails && JSON.parse(headQuartersDetails.replace(/'/g, '"')).addressLine1} */}
                          {headQuartersDetails.addressLine1}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "0px" }}>
                          Address Line 2 :&nbsp;
                        </Typography>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "37px" }}>
                          {/* {headQuartersDetails && JSON.parse(headQuartersDetails.replace(/'/g, '"')).addressLine2} */}
                          {headQuartersDetails.addressLine2}
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={4} mb={1}>
                      <Grid item xs={6}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          Country :&nbsp;
                        </Typography>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "37px" }}>
                          {/* {headQuartersDetails && JSON.parse(headQuartersDetails.replace(/'/g, '"')).country} */}
                          {headQuartersDetails.country}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text">
                          State :&nbsp;
                        </Typography>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "55px" }}>
                          {/* {headQuartersDetails && JSON.parse(headQuartersDetails.replace(/'/g, '"')).state} */}
                          {headQuartersDetails.state}
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={4} mb={1}>
                      <Grid item xs={6}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          City :&nbsp;
                        </Typography>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "65px" }}>
                          {/* {headQuartersDetails && JSON.parse(headQuartersDetails.replace(/'/g, '"')).city} */}
                          {headQuartersDetails.city}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text">
                          Pincode :&nbsp;
                        </Typography>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "37px" }}>
                          {/* {headQuartersDetails && JSON.parse(headQuartersDetails.replace(/'/g, '"')).pincode} */}
                          {headQuartersDetails.pincode}
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                      <Grid item xs={12}>
                        <Breadcrumbs
                          routes={[{ label: <span style={{ fontWeight: 'bold' }}>Training Partner's Social Media Details</span> }]}
                        />
                      </Grid>
                    </Grid>

                    <Grid container spacing={1} mb={1}>
                      <Grid item>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          LinkedIn URL :&nbsp;
                        </Typography>
                        {socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).linkedInUrl && (
                          <a
                            href={socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).linkedInUrl.startsWith("http") ? JSON.parse(socialMedia.replace(/'/g, '"')).linkedInUrl : `http://${JSON.parse(socialMedia.replace(/'/g, '"')).linkedInUrl}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ marginLeft: "5px", textDecoration: "underline" }}
                          >
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "49px", textDecoration: "underline", color: "blue" }}>
                              {JSON.parse(socialMedia.replace(/'/g, '"')).linkedInUrl}
                            </Typography>
                          </a>
                        )}
                      </Grid>
                    </Grid>

                    <Grid container spacing={1} mb={1}>
                      <Grid item>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          Facebook URL :&nbsp;
                        </Typography>
                        {socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).facebookUrl && (
                          <a
                            href={socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).facebookUrl.startsWith("http") ? JSON.parse(socialMedia.replace(/'/g, '"')).facebookUrl : `http://${JSON.parse(socialMedia.replace(/'/g, '"')).facebookUrl}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ marginLeft: "5px", textDecoration: "underline" }}
                          >
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "40px", textDecoration: "underline", color: "blue" }}>
                              {JSON.parse(socialMedia.replace(/'/g, '"')).facebookUrl}
                            </Typography>
                          </a>
                        )}
                      </Grid>
                    </Grid>

                    <Grid container spacing={1} mb={1}>
                      <Grid item>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          Twitter URL :&nbsp;
                        </Typography>
                        {socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).twitterUrl && (
                          <a
                            href={socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).twitterUrl.startsWith("http") ? JSON.parse(socialMedia.replace(/'/g, '"')).twitterUrl : `http://${JSON.parse(socialMedia.replace(/'/g, '"')).twitterUrl}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ marginLeft: "5px", textDecoration: "underline" }}
                          >
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "61px", textDecoration: "underline", color: "blue" }}>
                              {JSON.parse(socialMedia.replace(/'/g, '"')).twitterUrl}
                            </Typography>
                          </a>
                        )}
                      </Grid>
                    </Grid>

                    <Grid container spacing={1} mb={1}>
                      <Grid item>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          Instagram URL :&nbsp;
                        </Typography>
                        {socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).instagramUrl && (
                          <a
                            href={socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).instagramUrl.startsWith("http") ? JSON.parse(socialMedia.replace(/'/g, '"')).instagramUrl : `http://${JSON.parse(socialMedia.replace(/'/g, '"')).instagramUrl}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ marginLeft: "5px", textDecoration: "underline" }}
                          >
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "38px", textDecoration: "underline", color: "blue" }}>
                              {JSON.parse(socialMedia.replace(/'/g, '"')).instagramUrl}
                            </Typography>
                          </a>
                        )}
                      </Grid>
                    </Grid>

                    <Grid container spacing={1} mb={1}>
                      <Grid item>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          GitHub URL :&nbsp;
                        </Typography>
                        {socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).gitHubUrl && (
                          <a
                            href={socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).gitHubUrl.startsWith("http") ? JSON.parse(socialMedia.replace(/'/g, '"')).gitHubUrl : `http://${JSON.parse(socialMedia.replace(/'/g, '"')).gitHubUrl}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ marginLeft: "5px", textDecoration: "underline" }}
                          >
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "61px", textDecoration: "underline", color: "blue" }}>
                              {JSON.parse(socialMedia.replace(/'/g, '"')).gitHubUrl}
                            </Typography>
                          </a>
                        )}
                      </Grid>
                    </Grid>

                    <Grid container spacing={1} mb={1}>
                      <Grid item>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          Youtube URL :&nbsp;
                        </Typography>
                        {socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).youtubeUrl && (
                          <a
                            href={socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).youtubeUrl.startsWith("http") ? JSON.parse(socialMedia.replace(/'/g, '"')).youtubeUrl : `http://${JSON.parse(socialMedia.replace(/'/g, '"')).youtubeUrl}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ marginLeft: "5px", textDecoration: "underline" }}
                          >
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "52px", textDecoration: "underline", color: "blue" }}>
                              {JSON.parse(socialMedia.replace(/'/g, '"')).youtubeUrl}
                            </Typography>
                          </a>
                        )}
                      </Grid>
                    </Grid>

                  </Grid>
                </Grid>
                <Grid container justifyContent="center" spacing={2} mt={2} style={{ marginTop: "-40px", marginBottom: "-80px" }}>
                  <Grid item>
                    <MKButton
                      variant="gradient"
                      color="info"
                      size="small"
                      onClick={() => onDeclineClick()}
                      style={{ padding: '5px 10px' }}
                    >
                      Decline
                    </MKButton>
                  </Grid>
                  <Grid item>
                    <MKButton
                      variant="gradient"
                      color="info"
                      size="small"
                      onClick={() => onAgreeClick()}
                      style={{ padding: '5px 10px' }}
                    >
                      Agree
                    </MKButton>
                  </Grid>
                </Grid>
              </Grid>
            </Container>
          </MKBox>
        </Card>
        <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <MKBox position="center" zIndex={2} style={{ bottom: 0 }}>
            <SimpleFooter />
          </MKBox>
        </div>
      </MKBox>
    </>
  );
}

export default Author;
